import { useEffect, useRef } from "react";
import { io } from "socket.io-client";
import { useSelector } from "react-redux";
import appConfig from "configs/app.config";

const useSocket = () => {
  const userId = useSelector((state) => state.auth.user?._id);
  const socketRef = useRef(null);

  useEffect(() => {
    if (!userId) return;

    const socket = io(appConfig.apiBaseUrl, {
      transports: ["websocket"],
      autoConnect: true,
      query: {
        adminId: userId,
      },
    });

    socketRef.current = socket;

    socket.connect();

    return () => {
      socket.disconnect();
    };
  }, [userId]);

  return socketRef;
};

export default useSocket;
